import React, { memo, useEffect, useState } from 'react';
import styles from '../TcIndex/styles';
import { Table, TableBody, TableHeader, TableHeaderColumn } from 'material-ui';
import HiresTableRow from './HiresTableRow';
import { TooltipWrapper } from './utils';

function HiresTable({ rows, errors: _errors, changeFieldsMultiple }) {
    const [errors, setErrors] = useState(_errors);

    useEffect(() => {
        setErrors(_errors);
    }, [_errors]);

    return (
        <div>
            <Table selectable={false}>
                <TableHeader
                    displaySelectAll={false}
                    adjustForCheckbox={false}
                >
                    <TableHeaderColumn style={styles.headerCol}>IMO</TableHeaderColumn>
                    <TableHeaderColumn style={styles.headerColSm}>Type by purpose</TableHeaderColumn>
                    <TableHeaderColumn style={styles.headerColSm}>Type by construction</TableHeaderColumn>
                    <TableHeaderColumn style={styles.headerColSm}>Geared</TableHeaderColumn>
                    <TableHeaderColumn style={styles.headerColSm}>Max crane capacity</TableHeaderColumn>
                    <TableHeaderColumn style={{ ...styles.headerColSm, position: 'relative' }}>
                        <TooltipWrapper text='Picked by priority: Eco Laden, Eco Ballast, Laden, Ballast, Working, Idle with highest speed.' />
                        Speed & Cons
                    </TableHeaderColumn>
                    <TableHeaderColumn style={styles.headerCol}>DWT group*</TableHeaderColumn>
                    <TableHeaderColumn style={styles.headerCol}>Place from</TableHeaderColumn>
                    <TableHeaderColumn style={styles.headerCol}>Region from*</TableHeaderColumn>
                    <TableHeaderColumn style={styles.headerCol}>Place to</TableHeaderColumn>
                    <TableHeaderColumn style={styles.headerCol}>Region to*</TableHeaderColumn>
                    <TableHeaderColumn style={styles.headerCol}>LayCan*</TableHeaderColumn>
                    <TableHeaderColumn style={styles.headerColSm}>Hire type*</TableHeaderColumn>
                    <TableHeaderColumn style={styles.headerColSm}>Hire*</TableHeaderColumn>
                    <TableHeaderColumn style={{ ...styles.headerColSm, position: 'relative' }}>
                        <TooltipWrapper text='Parsed value. Changing will modify only vlsfo.' />
                        Fuel price
                    </TableHeaderColumn>
                    <TableHeaderColumn style={{ ...styles.headerCol, position: 'relative' }}>
                        <TooltipWrapper text='Main region.' />
                        Bunker place
                    </TableHeaderColumn>
                    <TableHeaderColumn style={styles.headerColSm}>Duration, d</TableHeaderColumn>
                    <TableHeaderColumn style={styles.headerCol}>Cargo Type</TableHeaderColumn>
                    <TableHeaderColumn style={styles.headerCol}>Cargo Region</TableHeaderColumn>
                    <TableHeaderColumn style={styles.headerColSm}>Delete</TableHeaderColumn>
                </TableHeader>
                <TableBody displayRowCheckbox={false}>
                    {
                        rows.map((row, rowIndex) => (
                            <HiresTableRow 
                                rowIndex={rowIndex}
                                key={`HiresTableRow__${row._id || row.uniqueId}_${rowIndex}`}
                                hireData={row}
                                errors={errors}
                                changeFieldsMultiple={changeFieldsMultiple}
                            />
                        ))
                    }
                </TableBody>
            </Table>
        </div>
    );
}

export default memo(HiresTable);



// WEBPACK FOOTER //
// ./app/components/Hires/HiresTable.jsx